export const stringToMb = (string: string) => ((string.length * 2) / (1024 * 1024)).toFixed(2)
